// extracted by mini-css-extract-plugin
export default {"container":"vazio_container__Kmrar","content":"vazio_content__qRwPV","mensagem":"vazio_mensagem__IxiVZ"};